import { render, staticRenderFns } from "./TabPurchaseInvoiceVatLines.vue?vue&type=template&id=b4814c1e"
import script from "./TabPurchaseInvoiceVatLines.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPurchaseInvoiceVatLines.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports